export default __webpack_public_path__ + "static/media/completion-time-chart.cbcba22a.svg";